import React, { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import {
  magStilInloggen, probeerStilInloggen, heeftStilControle, controleerStilResultaat, VERWORPEN,
} from "../utils/stilInloggen";
import { getDevSession } from "../utils/devSession";

// Nieuw tabblad zonder tokens (sessionStorage is per tabblad): eerst stil de bestaande
// Entra-sessie hergebruiken, pas daarna de app (of de inlogkaart) tonen. Zo flitst de
// inlogkaart niet en verdwijnt een deep link niet. Zie utils/stilInloggen.js.
// Staat in App.js direct binnen MsalProvider, dus vóór UserRoleProvider en de andere
// accountafhankelijke providers: niets doet een request onder een ongecontroleerd account.
const herlaadPagina = () => window.location.reload();
export default function StilInloggen({ children, herlaad = herlaadPagina }) {
  const { instance, inProgress } = useMsal();
  const [bezig, setBezig] = useState(
    () => !getDevSession() && (heeftStilControle() || magStilInloggen(instance)),
  );
  const gestart = useRef(false);
  const gemonteerd = useRef(true);
  useEffect(() => {
    gemonteerd.current = true;
    return () => { gemonteerd.current = false; };
  }, []);

  useEffect(() => {
    if (!bezig || gestart.current) return;
    // Eerst laat MsalProvider een eventuele redirect-terugkeer afhandelen.
    if (inProgress !== InteractionStatus.None) return;
    // Eén run; ssoSilent zelf zet inProgress weer op "bezig", dat mag deze run niet afbreken.
    gestart.current = true;
    (async () => {
      // Terug van de prompt=none-redirect: eerst controleren of het verwachte account terugkwam.
      const ok = await controleerStilResultaat(instance);
      if (!ok) return VERWORPEN;
      if (!magStilInloggen(instance)) return false;
      return probeerStilInloggen(instance, { redirectUri: process.env.REACT_APP_POPUP_REDIRECT_URI });
    })().catch(() => false).then((uitkomst) => {
      // Afgewezen account: cache is gewist; herladen zodat msal-react de lege cache ziet
      // (de eenmaligheidsvlag staat, dus daarna gewoon de inlogkaart — geen lus).
      if (uitkomst === VERWORPEN) { herlaad(); return; }
      if (gemonteerd.current) setBezig(false);
    });
  }, [bezig, inProgress, instance, herlaad]);

  if (bezig) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <CircularProgress size={32} />
      </Box>
    );
  }
  return children;
}
